import { render } from "./OffersPage.vue?vue&type=template&id=a5a95f4a&scoped=true"
import script from "./OffersPage.vue?vue&type=script&lang=js"
export * from "./OffersPage.vue?vue&type=script&lang=js"

import "./OffersPage.vue?vue&type=style&index=0&id=a5a95f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a95f4a"]])

export default __exports__